"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.active.help': 'Nieaktywne awatary nie są widoczne dla zwykłych użytkowników',
};
